/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type { MeasureJson } from '@/types/domain/measure/entities/measureEntity';
import type { MeasureStateType } from '@/types/domain/measure/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

import { service } from '@/share';

const initialState: MeasureStateType = {
  measureList: [],
  nextToken: null,
};

/**
 * 測定Slice
 */
export const measureSlice = createSlice({
  name: 'measure',
  initialState,
  reducers: {
    /** 測定リストをセット */
    setMeasureList:
      (state, action: PayloadAction<{
        nextToken: string,
        items: MeasureJson[],
      }>) => {
        state.measureList = action.payload.items;
        state.nextToken = action.payload.nextToken;
      },
    /** 作成 */
    createMeasureStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.measureList = service.measure.createMeasureStore(
        state.measureList,
        action.payload,
        undefined,
      );
    },
    /** 更新 */
    updateMeasureStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.measureList = service.measure.updateMeasureStore(
        state.measureList,
        action.payload,
      );
    },
    /** 削除 */
    deleteMeasureStore: (state, action: PayloadAction<DeleteOutputType>) => {
      state.measureList = service.measure.deleteMeasureStore(
        state.measureList,
        action.payload,
      );
    },
  },
});
